"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineLazyValueStore = defineLazyValueStore;
exports.LazyValueState = void 0;

var _ActionVerbs = require("../actions/ActionVerbs");

var _Dispatch = require("../dispatch/Dispatch");

var _generalStore = _interopRequireDefault(require("general-store"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _immutable = require("immutable");

var _MakeActions = require("../actions/MakeActions");

var _LoadingStatus = require("../constants/LoadingStatus");

var LazyValueState = (0, _immutable.Record)({
  promise: null,
  value: _LoadingStatus.LOADING
}, 'LazyValueState');
exports.LazyValueState = LazyValueState;

function defineLazyValueStore(_ref) {
  var fetch = _ref.fetch,
      namespace = _ref.namespace,
      _ref$responseTransfor = _ref.responseTransform,
      responseTransform = _ref$responseTransfor === void 0 ? _identity.default : _ref$responseTransfor,
      _ref$getterTransform = _ref.getterTransform,
      getterTransform = _ref$getterTransform === void 0 ? function (_ref2) {
    var value = _ref2.value;
    return value;
  } : _ref$getterTransform;

  var _makeAsyncActionTypes = (0, _MakeActions.makeAsyncActionTypes)(namespace, _ActionVerbs.FETCH),
      QUEUED = _makeAsyncActionTypes.QUEUED,
      STARTED = _makeAsyncActionTypes.STARTED,
      FAILED = _makeAsyncActionTypes.FAILED,
      SUCCEEDED = _makeAsyncActionTypes.SUCCEEDED;

  return _generalStore.default.defineFactory().defineName(namespace + "_LazyValueStore").defineGetInitialState(LazyValueState).defineGet(function (state, options) {
    if (options && options.forceRefresh) {
      (0, _Dispatch.dispatchQueue)(QUEUED, options);
    } else if (!state.promise) {
      (0, _Dispatch.dispatchQueue)(QUEUED);
    }

    return getterTransform({
      value: state.value,
      options: options
    });
  }).defineResponseTo(QUEUED, function (state) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (state.promise && !options.forceRefresh) {
      return state;
    }

    var promise = fetch();
    (0, _Dispatch.dispatchQueue)(STARTED);
    promise.then(function (value) {
      return (0, _Dispatch.dispatchImmediate)(SUCCEEDED, value);
    }, function () {
      return (0, _Dispatch.dispatchImmediate)(FAILED);
    }).done();
    return state.set('promise', promise);
  }).defineResponseTo(SUCCEEDED, function (state, value) {
    return state.set('value', responseTransform(value));
  }).defineResponseTo(FAILED, function (state) {
    return state.set('value', _LoadingStatus.EMPTY);
  });
}